import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import Axios from "axios";
import config from '../Componentes/config';

function PermisosModal({ show, onHide, cookies }) {
    const [usuarios, setUsuarios] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [selectedUsuario, setSelectedUsuario] = useState(null);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [permisosEmpresa, setPermisosEmpresa] = useState([]);
    const [permisosModulo, setPermisosModulo] = useState([]);
    const [loading, setLoading] = useState(false);

    // Cargar datos cuando se abre el modal
    useEffect(() => {
        if (show) {
            cargarUsuarios();
            cargarEmpresas();
            cargarModulos();
        }
    }, [show]);

    const cargarUsuarios = () => {
        Axios.get(`${config.API_URL}/getAllUsuarios`)
            .then(response => {
                // Validación defensiva para asegurar que sea un array
                const usuarios = Array.isArray(response.data) ? response.data : [];
                setUsuarios(usuarios);
            })
            .catch(error => {
                console.error("Error al cargar usuarios:", error);
                setUsuarios([]); // Array vacío en caso de error
            });
    };

    const cargarEmpresas = () => {
        Axios.get(`${config.API_URL}/getAllEmpresas`)
            .then(response => {
                // Validación defensiva para asegurar que sea un array
                const empresas = Array.isArray(response.data) ? response.data : [];
                setEmpresas(empresas);
            })
            .catch(error => {
                console.error("Error al cargar empresas:", error);
                setEmpresas([]); // Array vacío en caso de error
            });
    };

    const cargarModulos = () => {
        Axios.get(`${config.API_URL}/getAllModulos`)
            .then(response => {
                // Validación defensiva para asegurar que sea un array
                const modulos = Array.isArray(response.data) ? response.data : [];

                // Organizar módulos por jerarquía
                const modulosPadre = modulos.filter(m => m.Tipo === 'Modulo');
                const submodulos = modulos.filter(m => m.Tipo === 'Submodulo');

                // Organizar en estructura jerárquica
                const modulosJerarquicos = modulosPadre.map(padre => ({
                    ...padre,
                    submodulos: submodulos.filter(sub => sub.ID_Modulo_Padre === padre.ID)
                        .sort((a, b) => a.Orden - b.Orden)
                }));

                setModulos(modulosJerarquicos);
            })
            .catch(error => {
                console.error("Error al cargar módulos:", error);
                setModulos([]); // Array vacío en caso de error
            });
    };

    const cargarPermisosUsuario = (usuarioId) => {
        // Cargar permisos de empresa
        Axios.get(`${config.API_URL}/getPermisosEmpresaUsuario`, { params: { userId: usuarioId } })
            .then(response => {
                // Validación defensiva para asegurar que sea un array
                const permisos = Array.isArray(response.data) ? response.data : [];
                setPermisosEmpresa(permisos.map(p => p.ID_Empresa));
            })
            .catch(error => {
                console.error("Error al cargar permisos de empresa:", error);
                setPermisosEmpresa([]); // Array vacío en caso de error
            });

        // Limpiar permisos de módulo al cambiar usuario
        setPermisosModulo([]);
        setSelectedEmpresa(null);
    };

    const cargarPermisosModulosEmpresa = (usuarioId, empresaId) => {
        if (!usuarioId || !empresaId) {
            setPermisosModulo([]);
            return;
        }

        // Cargar permisos de módulo específicos para la empresa seleccionada
        Axios.get(`${config.API_URL}/getPermisosModulosUsuario`, {
            params: { userId: usuarioId, empresaId: empresaId }
        })
            .then(response => {
                // Validación defensiva para asegurar que sea un array
                const permisos = Array.isArray(response.data) ? response.data : [];
                setPermisosModulo(permisos.map(p => p.ID_Modulo));
            })
            .catch(error => {
                console.error("Error al cargar permisos de módulo:", error);
                setPermisosModulo([]); // Array vacío en caso de error
            });
    };

    const handleUsuarioSelect = (e) => {
        const usuarioId = e.target.value;
        if (usuarioId) {
            // Validación defensiva para asegurar que usuarios sea un array
            const usuariosArray = Array.isArray(usuarios) ? usuarios : [];
            const usuario = usuariosArray.find(u => u.ID == usuarioId);
            setSelectedUsuario(usuario);
            setSelectedEmpresa(null);
            cargarPermisosUsuario(usuarioId);
        } else {
            setSelectedUsuario(null);
            setSelectedEmpresa(null);
            setPermisosEmpresa([]);
            setPermisosModulo([]);
        }
    };

    const handleEmpresaSelect = (empresa) => {
        setSelectedEmpresa(empresa);
        if (selectedUsuario) {
            cargarPermisosModulosEmpresa(selectedUsuario.ID, empresa.ID_Empresa);
        }
    };

    const handleEmpresaClick = (empresa) => {
        setSelectedEmpresa(empresa);
        if (selectedUsuario) {
            cargarPermisosModulosEmpresa(selectedUsuario.ID, empresa.ID_Empresa);
        }
    };

    const togglePermisoEmpresa = (empresaId) => {
        const hasPermission = permisosEmpresa.includes(empresaId);

        if (hasPermission) {
            // Remover permiso
            Axios.delete(`${config.API_URL}/removePermisoEmpresa`, {
                data: { userId: selectedUsuario.ID, empresaId }
            })
                .then(() => {
                    setPermisosEmpresa(prev => prev.filter(id => id !== empresaId));
                })
                .catch(error => {
                    console.error("Error al remover permiso de empresa:", error);
                });
        } else {
            // Añadir permiso
            Axios.post(`${config.API_URL}/addPermisoEmpresa`, {
                userId: selectedUsuario.ID,
                empresaId
            })
                .then(() => {
                    setPermisosEmpresa(prev => [...prev, empresaId]);
                })
                .catch(error => {
                    console.error("Error al añadir permiso de empresa:", error);
                });
        }
    };

    const togglePermisoModulo = (moduloId) => {
        if (!selectedEmpresa) {
            alert('Primero debes seleccionar una empresa para gestionar permisos de módulos');
            return;
        }

        const hasPermission = permisosModulo.includes(moduloId);

        // Buscar si es un módulo padre o submódulo - validación defensiva
        const modulosArray = Array.isArray(modulos) ? modulos : [];
        const moduloPadre = modulosArray.find(m => m.ID === moduloId);
        const esModuloPadre = moduloPadre && moduloPadre.Tipo === 'Modulo';

        if (hasPermission) {
            // Remover permiso
            Axios.delete(`${config.API_URL}/removePermisoModulo`, {
                data: {
                    userId: selectedUsuario.ID,
                    moduloId: moduloId,
                    empresaId: selectedEmpresa.ID_Empresa
                }
            })
                .then(() => {
                    let nuevosPermisos = permisosModulo.filter(id => id !== moduloId);

                    // Si es módulo padre, también remover todos sus submódulos
                    if (esModuloPadre && moduloPadre.submodulos && Array.isArray(moduloPadre.submodulos)) {
                        const submodulosIds = moduloPadre.submodulos.map(sub => sub.ID);

                        // Remover submódulos del servidor
                        submodulosIds.forEach(subId => {
                            if (permisosModulo.includes(subId)) {
                                Axios.delete(`${config.API_URL}/removePermisoModulo`, {
                                    data: {
                                        userId: selectedUsuario.ID,
                                        moduloId: subId,
                                        empresaId: selectedEmpresa.ID_Empresa
                                    }
                                }).catch(error => {
                                    console.error("Error al remover permiso de submódulo:", error);
                                });
                            }
                        });

                        // Remover submódulos del estado local
                        nuevosPermisos = nuevosPermisos.filter(id => !submodulosIds.includes(id));
                    }

                    setPermisosModulo(nuevosPermisos);
                })
                .catch(error => {
                    console.error("Error al remover permiso de módulo:", error);
                });
        } else {
            // Añadir permiso
            Axios.post(`${config.API_URL}/addPermisoModulo`, {
                userId: selectedUsuario.ID,
                moduloId: moduloId,
                empresaId: selectedEmpresa.ID_Empresa
            })
                .then(() => {
                    setPermisosModulo(prev => [...prev, moduloId]);
                })
                .catch(error => {
                    console.error("Error al añadir permiso de módulo:", error);
                });
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-users-cog mr-2"></i>
                    Gestión de Permisos de Usuarios
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Row>
                    {/* Selector de usuario */}
                    <Col md={12} className="mb-3">
                        <Form.Group>
                            <Form.Label><strong>Seleccionar Usuario:</strong></Form.Label>
                            <Form.Control as="select" onChange={handleUsuarioSelect}>
                                <option value="">-- Selecciona un usuario --</option>
                                {Array.isArray(usuarios) && usuarios.map(usuario => (
                                    <option key={usuario.ID} value={usuario.ID}>
                                        {usuario.Nombres} {usuario.Apellidos} ({usuario.Usuario})
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>

                {selectedUsuario ? (
                    <Row>
                        {/* Información del usuario seleccionado */}
                        <Col md={12} className="mb-3">
                            <div className="alert alert-info">
                                <h6><i className="fas fa-user mr-2"></i>Usuario seleccionado:</h6>
                                <p className="mb-0">
                                    <strong>{selectedUsuario.Nombres} {selectedUsuario.Apellidos}</strong><br />
                                    Usuario: {selectedUsuario.Usuario} | Email: {selectedUsuario.Mail}
                                </p>
                            </div>
                        </Col>

                        {/* Permisos de Empresa */}
                        <Col md={12} className="mb-3">
                            <div className="card">
                                <div className="card-header bg-primary text-white">
                                    <h6 className="mb-0">
                                        <i className="fas fa-building mr-2"></i>
                                        Acceso a Empresas
                                    </h6>
                                    <small>Selecciona las empresas y luego haz clic en "Gestionar Módulos"</small>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        {Array.isArray(empresas) && empresas.map(empresa => (
                                            <div key={empresa.ID_Empresa} className="col-md-4 mb-3">
                                                <div className={`card h-100 ${permisosEmpresa.includes(empresa.ID_Empresa) ? 'border-success' : 'border-secondary'}`}>
                                                    <div className="card-body p-3">
                                                        <div className="form-check mb-2">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`empresa-${empresa.ID_Empresa}`}
                                                                checked={permisosEmpresa.includes(empresa.ID_Empresa)}
                                                                onChange={() => togglePermisoEmpresa(empresa.ID_Empresa)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`empresa-${empresa.ID_Empresa}`}>
                                                                <strong className="d-block">{empresa.Nombre_Empresa}</strong>
                                                                <small className="text-muted">RUT: {empresa.Rut_Empresa}</small>
                                                            </label>
                                                        </div>
                                                        {permisosEmpresa.includes(empresa.ID_Empresa) && (
                                                            <button
                                                                className={`btn btn-sm w-100 ${selectedEmpresa?.ID_Empresa === empresa.ID_Empresa ? 'btn-primary' : 'btn-outline-primary'}`}
                                                                onClick={() => handleEmpresaSelect(empresa)}
                                                            >
                                                                <i className="fas fa-cogs mr-1"></i>
                                                                {selectedEmpresa?.ID_Empresa === empresa.ID_Empresa ? 'Gestionando' : 'Gestionar Módulos'}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Información para gestionar módulos */}
                        {selectedUsuario && !selectedEmpresa && permisosEmpresa.length > 0 && (
                            <Col md={12}>
                                <div className="alert alert-info text-center">
                                    <i className="fas fa-info-circle fa-2x mb-2"></i>
                                    <h6>Gestión de Permisos de Módulos</h6>
                                    <p className="mb-0">
                                        Para gestionar los permisos de módulos, primero selecciona una empresa
                                        haciendo clic en "Gestionar Módulos" en cualquier empresa marcada.
                                    </p>
                                </div>
                            </Col>
                        )}

                        {/* Permisos de Módulo por Empresa */}
                        {selectedEmpresa && (
                            <Col md={12}>
                                <div className="card">
                                    <div className="card-header bg-success text-white">
                                        <h6 className="mb-0">
                                            <i className="fas fa-th-large mr-2"></i>
                                            Permisos de Módulos - {selectedEmpresa.Nombre_Empresa}
                                        </h6>
                                        <small>Usuario: {selectedUsuario.Nombres} {selectedUsuario.Apellidos}</small>
                                    </div>
                                    <div className="card-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        <div className="row">
                                            {Array.isArray(modulos) && modulos.map(modulo => (
                                                <div key={modulo.ID} className="col-md-6 mb-3">
                                                    <div className="card">
                                                        <div className="card-header py-2">
                                                            {/* Módulo principal */}
                                                            <div className="form-check mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`modulo-${modulo.ID}`}
                                                                    checked={permisosModulo.includes(modulo.ID)}
                                                                    onChange={() => togglePermisoModulo(modulo.ID)}
                                                                />
                                                                <label className="form-check-label font-weight-bold" htmlFor={`modulo-${modulo.ID}`}>
                                                                    <i className="fas fa-folder mr-2"></i>{modulo.Modulo}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        {/* Submódulos - Solo mostrar si el usuario tiene acceso al módulo padre */}
                                                        {modulo.submodulos && Array.isArray(modulo.submodulos) && modulo.submodulos.length > 0 && permisosModulo.includes(modulo.ID) && (
                                                            <div className="card-body py-2">
                                                                {modulo.submodulos.map(submodulo => (
                                                                    <div key={submodulo.ID} className="form-check mb-1 ml-3">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`submodulo-${submodulo.ID}`}
                                                                            checked={permisosModulo.includes(submodulo.ID)}
                                                                            onChange={() => togglePermisoModulo(submodulo.ID)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`submodulo-${submodulo.ID}`}>
                                                                            <i className="fas fa-file mr-2"></i>{submodulo.Modulo}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                ) : (
                    <div className="text-center py-5">
                        <i className="fas fa-users fa-4x text-gray-300 mb-3"></i>
                        <h5 className="text-gray-600">Selecciona un usuario para gestionar sus permisos</h5>
                        <p className="text-gray-500">
                            Podrás asignar o quitar acceso a empresas y módulos del sistema
                        </p>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    <i className="fas fa-times mr-2"></i>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PermisosModal;
